var _style, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRules(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.2,20.1c-0.2-0.2-0.5-0.4-0.8-0.4h-1.5V5.4c0-0.3-0.1-0.6-0.4-0.8c-0.2-0.2-0.5-0.4-0.8-0.4H7.9 c-0.7,0-1.2,0.5-1.2,1.2v14.4H5.2C4.5,19.8,4,20.3,4,21v5.6c0,0.3,0.1,0.6,0.4,0.8c0.2,0.2,0.5,0.4,0.8,0.4h22.2 c0.3,0,0.6-0.1,0.8-0.4c0.2-0.2,0.4-0.5,0.4-0.8V21C28.6,20.7,28.5,20.4,28.2,20.1z M24.1,19.8h-1c-0.4,0-0.8,0.2-1,0.5l-1.1,1.6 l-9.3,0l-1.1-1.6c-0.2-0.3-0.6-0.5-1-0.5h-1V6h15.6V19.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.6,
    y: 12.2,
    className: "st0",
    width: 8.4,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6,
    y: 12.2,
    className: "st0",
    width: 1.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.6,
    y: 8.3,
    className: "st0",
    width: 8.4,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6,
    y: 8.3,
    className: "st0",
    width: 1.8,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.6,
    y: 16.1,
    className: "st0",
    width: 8.4,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6,
    y: 16.1,
    className: "st0",
    width: 1.8,
    height: 1.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRules);
export default __webpack_public_path__ + "static/media/rules.b36c8487.svg";
export { ForwardRef as ReactComponent };